import * as types from './mutation-types.js';

export default {
    //设置当前登录账户id
    [types.SETMEMBER](state,member){
        state.member = member;
    },
}